var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArb = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#2C374B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_623_806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.1696 11.296V20.704C6.1696 21.3088 6.4864 21.856 7.0144 22.1632L15.1648 26.8672C15.6832 27.1648 16.3264 27.1648 16.8448 26.8672L24.9952 22.1632C25.5136 21.8656 25.84 21.3088 25.84 20.704V11.296C25.84 10.6912 25.5232 10.144 24.9952 9.83681L16.8448 5.13281C16.3264 4.83521 15.6832 4.83521 15.1648 5.13281L7.0144 9.83681C6.496 10.1344 6.1792 10.6912 6.1792 11.296H6.1696Z",
    fill: "#213147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.776 17.824L16.6144 21.0112C16.5856 21.0976 16.5856 21.1936 16.6144 21.2896L18.6112 26.7712L20.9248 25.4368L18.1504 17.824C18.0832 17.6512 17.8432 17.6512 17.776 17.824Z",
    fill: "#12AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1088 12.4671C20.0416 12.2943 19.8016 12.2943 19.7344 12.4671L18.5728 15.6543C18.544 15.7407 18.544 15.8367 18.5728 15.9327L21.8464 24.9087L24.16 23.5743L20.1088 12.4767V12.4671Z",
    fill: "#12AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5.488C16.0576 5.488 16.1152 5.5072 16.1632 5.536L24.976 10.624C25.0816 10.6816 25.1392 10.7968 25.1392 10.912V21.088C25.1392 21.2032 25.072 21.3184 24.976 21.376L16.1632 26.464C16.1152 26.4928 16.0576 26.512 16 26.512C15.9424 26.512 15.8848 26.4928 15.8368 26.464L7.024 21.376C6.9184 21.3184 6.8608 21.2032 6.8608 21.088V10.9024C6.8608 10.7872 6.928 10.672 7.024 10.6144L15.8368 5.5264C15.8848 5.4976 15.9424 5.4784 16 5.4784V5.488ZM16 4C15.6832 4 15.376 4.0768 15.088 4.24L6.2752 9.328C5.7088 9.6544 5.3632 10.2496 5.3632 10.9024V21.0784C5.3632 21.7312 5.7088 22.3264 6.2752 22.6528L15.088 27.7408C15.3664 27.904 15.6832 27.9808 16 27.9808C16.3168 27.9808 16.624 27.904 16.912 27.7408L25.7248 22.6528C26.2912 22.3264 26.6368 21.7312 26.6368 21.0784V10.9024C26.6368 10.2496 26.2912 9.6544 25.7248 9.328L16.9024 4.24C16.624 4.0768 16.3072 4 15.9904 4H16Z",
    fill: "#9DCCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1631 24.9184L10.9791 22.6912L12.6111 24.0448L11.0847 25.4464L10.1631 24.9184Z",
    fill: "#213147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2512 10.1823H13.0144C12.8512 10.1823 12.6976 10.2879 12.64 10.4415L7.84959 23.5743L10.1632 24.9087L15.4432 10.4415C15.4912 10.3071 15.3952 10.1727 15.2608 10.1727L15.2512 10.1823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.168 10.1823H16.9312C16.768 10.1823 16.6144 10.2879 16.5568 10.4415L11.0848 25.4367L13.3984 26.7711L19.3504 10.4415C19.3984 10.3071 19.3024 10.1727 19.168 10.1727V10.1823Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_623_806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ARB.730f05517e275d936d1a4456ac0a77e2.svg";